import { defineMessages } from 'react-intl';

/**
 * Translation messages for the occasion registration panel
 * (header labels and the sidepanel close button).
 */
export const messages = defineMessages({
  Close: {
    id: 'occasionRegistration.close',
    defaultMessage: 'Close',
  },
  DateLabel: {
    id: 'occasionRegistration.dateLabel',
    defaultMessage: 'Datum',
  },
  PlaceLabel: {
    id: 'occasionRegistration.placeLabel',
    defaultMessage: 'Durchführungsort',
  },
  // Shown when the page chosen as the CMS form path does not actually contain an
  // event-registration form (a plain form would silently fail to receive the
  // occasion's hidden fields — issue #1663).
  NoRegistrationForm: {
    id: 'occasionRegistration.noRegistrationForm',
    defaultMessage:
      'Die ausgewählte Seite enthält kein Event-Anmeldeformular. Bitte im Durchführungs-Feld „Pfad für Formular“ eine Seite mit einem Event-Anmeldeformular wählen.',
  },
  // Shown when fetching the CMS form page fails (network / permission / 404), so
  // the panel surfaces an error instead of looping the loader forever (#1663).
  FormLoadError: {
    id: 'occasionRegistration.formLoadError',
    defaultMessage:
      'Das Anmeldeformular konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
  },
});
